import React, { useEffect, useState } from 'react';
import {
    Container,
    Typography,
    List,
    ListItemButton,
    ListItemText,
    Chip,
    Box,
    CircularProgress,
    Paper,
    Button
} from '@mui/material';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { useNavigate } from 'react-router-dom';
import ApiService from '../network/API';

export const GroupsPage = () => {
    const navigate = useNavigate();
    const [groups, setGroups] = useState(null);
    const [error, setError] = useState(null);

    useEffect(() => {
        ApiService.getAllGroups()
            .then(setGroups)
            .catch((err) => setError(err.message || 'Не удалось загрузить группы'));
    }, []);

    if (error) {
        return (
            <Container maxWidth="md" sx={{ py: 4 }}>
                <Typography color="error">{error}</Typography>
            </Container>
        );
    }

    if (!groups) {
        return (
            <Box display="flex" justifyContent="center" py={10}>
                <CircularProgress />
            </Box>
        );
    }

    return (
        <Container maxWidth="md" sx={{ py: 4 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 1, mb: 3 }}>
                <Typography variant="h5" fontWeight={700}>
                    Группы
                </Typography>
                <Button variant="outlined" color="warning" startIcon={<WarningAmberIcon />} onClick={() => navigate('/groups/auto-grades')}>
                    Где выключено автообновление оценок
                </Button>
            </Box>

            {groups.length === 0 ? (
                <Typography color="text.secondary">Групп пока нет.</Typography>
            ) : (
                <Paper variant="outlined" sx={{ borderRadius: 2, overflow: 'hidden' }}>
                    <List disablePadding>
                        {groups.map((group) => (
                            <ListItemButton
                                key={group.id}
                                onClick={() => navigate(`/groups/${group.id}`)}
                                divider
                            >
                                <ListItemText primary={group.name} />
                                <Chip label={`${group.studentsCount} студ.`} size="small" />
                            </ListItemButton>
                        ))}
                    </List>
                </Paper>
            )}
        </Container>
    );
};

export default GroupsPage;
